module.exports = __webpack_public_path__ + "static/card-lang-04-5f535fd03549d649c46b39249dc31f86.jpg";